/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForZohoServiceDeskOnPremise extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForZohoServiceDeskOnPremise");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForZohoServiceDeskOnPremise.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForZohoServiceDeskOnPremise>): ServiceAccountCredentialsForZohoServiceDeskOnPremise {
        let obj = Object.assign(new ServiceAccountCredentialsForZohoServiceDeskOnPremise(), model);
        ServiceAccountCredentialsForZohoServiceDeskOnPremise.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForZohoServiceDeskOnPremise>): ServiceAccountCredentialsForZohoServiceDeskOnPremise {
        if (!model) return null;
        return ServiceAccountCredentialsForZohoServiceDeskOnPremise.newInstance(<ServiceAccountCredentialsForZohoServiceDeskOnPremise> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForZohoServiceDeskOnPremise) {
        if (!obj) return;

        models.ServiceAccountCredentialsForZohoServiceDeskOnPremise.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForZohoServiceDeskOnPremise): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForZohoServiceDeskOnPremise.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Auth URL. This is a required field.
     */
    auth_url: string;

    /**
     * Auth Token. This is a required field.
     */
    auth_token: string;

    /**
     * SSL Verify enabled or not
     */
    ssl_verify: boolean;

    /**
     * API version
     */
    api_version: models.ZohoServiceDeskAPIVersion;

}
